import { render, staticRenderFns } from "./vue-multiselect.html?vue&type=template&id=524c37fe&scoped=true&external"
import script from "./vue-multiselect.js?vue&type=script&lang=js&external"
export * from "./vue-multiselect.js?vue&type=script&lang=js&external"
import style0 from "./vue-multiselect.scss?vue&type=style&index=0&id=524c37fe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c37fe",
  null
  
)

export default component.exports